// const requireComponent = require.context('./', true, /\.vue$/);
//
// const install = (Vue) => {
//     if (install.installed) return
//     install.installed
//     requireComponent.keys().forEach(fileName => {
//         //第i个组件
//         const config = requireComponent(fileName);
//         //组件名
//         const componentName = config.default.name;
//
//         Vue.component(componentName, config.default || config);
//     });
// }
//
// //确保是浏览器环境
// if(typeof window !== 'undefind' && window.Vue){
//     install(window.Vue);
// }
//
// export  default{
//     install
// }
// import DtSearchBar from "./dt-seachbar";
// import DtTable from "./dt-table";
import DtBreadcrumb from "./dt-breadcrumb";
// import DtSearchAreaSelect from "./dt-searchAreaSelect";


const components = [DtBreadcrumb];

const install = function (Vue) {
    components.forEach(component => {
        Vue.component(component.name, component);
    });
};

if (typeof window !== "undefined" && window.Vue) {
    install(window.Vue);
}

export default {
    install,
    DtBreadcrumb
};
